// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import exclude from './router/exclude'
import include from './router/include'
import 'babel-polyfill'
import './assets/iconfont/iconfont.css'
import './assets/menuIcon/iconfont.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ElementUI from 'element-ui'
Vue.use(VueQuillEditor)
import '../theme/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/reset.css'
import Velocity from 'velocity-animate'
import { store } from './store/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);
import MyGlobal from '@/components/base/Global'
import moment from 'moment'
Vue.prototype.$moment = moment
import utils from './utils/index.js'
import './utils/permission.js'
// 埋点js
import './assets/js/loghub-tracking.js'
import Track from './utils/web-tracking';
Vue.prototype.$Track = Track;

import ChartMask from '@/components/base/charts/ChartMask'
import MyPanel from '@/components/base/panel/Panel'
import ClickHere from '@/components/base/label/ClickHere'
import NoData from '@/components/base/noDataTip/NoData'
import NoFound from '@/components/base/noFound/noFound'
import CompareCart from '@/components/base/compare/Compare'
import MyPanelContainer from '@/components/base/panel/PanelContainer'
import MyButton from '@/components/base/button/Button'
import MyBlockHeader from '@/components/base/header/BlockHeader'
import FDiv from '@/components/base/panel/FloatDiv'
import MDiv from '@/components/base/panel/MarginDiv'
import MyLetterSearch from '@/components/base/letterSearch/LetterSearch'
import MyLetterSearchBoss from '@/components/base/letterSearch/LetterSearchBoss'
import MySearchList from '@/components/base/letterSearch/SearchList'
import MySearchListBoss from '@/components/base/letterSearch/SearchListBoss'
import MySearchBossClaims from '@/components/base/letterSearch/SearchListBossClaims'
import MyLetter from '@/components/base/letterSearch/Letter'
import MyConsumerLetter from '@/components/base/letterSearch/ConsumerLetter'
import MyLetterBoss from '@/components/base/letterSearch/LetterBoss'
import MyFirstLabel from '@/components/base/letterSearch/FirstLabel'
import MyCheckBox from '@/components/base/form/CheckBox'
import vueProgressBar from 'svg-progress-bar'

import targetUser from '@/components/base/targetUsers/targetUser'
import targetRole from '@/components/base/targetUsers/targetRole'
import baseNoData from '@/components/base/baseNoData'

Vue.directive('enterNumber', {
  inserted: function (el) {
    el.addEventListener("keypress", function (e) {
      e = e || window.event;
      let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
      let re = /\d/;
      if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
      }
    });
  }
});

//自定义指令
import '@/directive/index'

Vue.component('chart-mask', ChartMask)
Vue.component('my-panel', MyPanel)
Vue.component('click-here', ClickHere)
Vue.component('no-data', NoData)
Vue.component('no-found', NoFound)
Vue.component('my-panel-container', MyPanelContainer)
Vue.component('my-button', MyButton)
Vue.component('my-block-header', MyBlockHeader)
Vue.component('f-div', FDiv)
Vue.component('m-div', MDiv)
Vue.component('my-letter-search', MyLetterSearch)
Vue.component('my-letter-search-boss', MyLetterSearchBoss)
Vue.component('my-search-list', MySearchList)
Vue.component('my-search-list-boss', MySearchListBoss)
Vue.component('my-search-boss-claims', MySearchBossClaims)
Vue.component('my-letter', MyLetter)
Vue.component('my-consumer-letter', MyConsumerLetter)
Vue.component('my-letter-boss', MyLetterBoss)
Vue.component('my-first-label', MyFirstLabel)
Vue.component('my-check-box', MyCheckBox)
Vue.component('svg-bar', vueProgressBar)
Vue.component('compare-cart', CompareCart)
Vue.component('my-global', MyGlobal)
Vue.component('target-user', targetUser)
Vue.component('target-role', targetRole)
Vue.component('base-no-data', baseNoData)
import { i18n } from './lang/i18n'
// axios.defaults.baseURL ='http://192.168.1.118:9090'
// axios.defaults.baseURL ='http://dlite3-report.basf.com:9444'
// axios.defaults.header.common['Authorization'] = 'token'

import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$utils = utils
Vue.prototype.$exclude = exclude
Vue.prototype.$include = include

// 默认会找 Filters/index.js
import * as filters from './filters/'

// 遍历所有导出的过滤器并添加到全局过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer)
import 'videojs-contrib-hls'
// require('videojs-contrib-hls/dist/videojs-contrib-hls')
/* eslint-disable no-new */

let vue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

window.$lang = function (txt, params) {
  return vue.$t(txt, params)
}



// WEBPACK FOOTER //
// ./src/main.js